<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h6>Настройки графика работы дивизионов</h6>
      </div>
      <div class="card-body" v-if="!loading && records">
        <table class="table table-sm table-hover">
          <thead>
          <tr>
            <th>Дивизион</th>
            <th>Выходные</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="division in $AllDivisions" v-if="division.is_active">
            <td>
              {{ mixinGetDivisionName(division) }}
            </td>
            <td>
              <div v-if="!records[division.id].data.free_days || !records[division.id].data.free_days.length">
                <p>Без выходных</p>
              </div>
              <div v-for="(record, index) in records[division.id].data.free_days" class="flex">
                <template v-if="!record.delete">
                  <select v-model="record.city_id" class="form-control">
                    <option :value="0">Все города</option>
                    <option v-for="(c, i) in division.cities" :value="c.city.id">{{ c.city.name }}</option>
                  </select>
                  <select v-model="record.day_num" class="form-control">
                    <option v-for="(name, num) in days" :value="num">{{ name }}</option>
                  </select>
                  <div class="small_w">
                    <TimeSelect
                      :selectedDate="record.time"
                      :onSelect="(time) => record.time = time"
                      :disabled="true"
                    />
                  </div>
                  <button class="btn btn-outline-danger" @click="deleteRecord(division.id, index)">
                    <i class="icon-fa icon-fa-trash-o" aria-hidden="true"></i>
                  </button>
                </template>
              </div>
            </td>
            <td>
              <button @click="addNewRecord(division.id)" class="btn btn-outline-info btn-sm">добавить запись</button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="text-right">
          <LoadingButton
            title="Сохранить"
            className="btn btn-success btn-xs mb-1"
            :onClick="updateRecords"
            :loading="btnLoading"
            color="white"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import TimeSelect from "@/components/dateSelect/TimeSelect";
import LoadingButton from "@/components/buttons/LoadingButton"

export default {
  components: {
    TimeSelect,
    LoadingButton,
  },
  computed: {
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    },
  },
  data() {
    return {
      loading: false,
      btnLoading: false,
      records: null,
      days: {
        1: 'Понедельник',
        2: 'Вторник',
        3: 'Среда',
        4: 'Четверг',
        5: 'Пятница',
        6: 'Суббота',
        7: 'Воскресенье',
      }
    }
  },
  mounted() {
    this.getDivisionTimesheet();
  },
  methods: {
    async getDivisionTimesheet() {
      this.loading = true;
      const {data} = await api.index('settings/stores/workingtime');
      const arr = {};
      Object.values(this.$AllDivisions).forEach((d) => {
        if (!data.records[d.id]) {
          arr[d.id] = {data: {free_days: []}};
        } else {
          arr[d.id] = data.records[d.id];
        }
      })
      this.records = arr;
      this.loading = false;
    },
    addNewRecord(divId) {
      this.records[divId].data.free_days.push({
        day_num: 1,
        time: '00:00:00',
        city_id: 0
      });
    },
    deleteRecord(divId, index) {
      this.records[divId].data.free_days[index].delete = true;
      this.records[divId].data.free_days = [...this.records[divId].data.free_days];
    },
    async updateRecords() {
      this.btnLoading = true;
      const {data} = await api.post('settings/stores/workingtime', {
        records: this.records
      });
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
        await this.getDivisionTimesheet();
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.btnLoading = false;

    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 2px;
}

.small_w {
  min-width: 110px;
}

button i {
  text-align: center;
}
</style>
